/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { PerformanceData } from '../types';
import { Panel } from '../components/UIComponents';
import { collapsedViewStyles, requestsViewStyles } from '../styles';

interface RequestsViewProps {
  requests: PerformanceData[];
  onSelectRequest: (mode: 'sql' | 'bullet' | 'memory', requestId: string) => void;
  onBack: () => void;
  onClose: () => void;
}

export const RequestsView: React.FC<RequestsViewProps> = ({ requests, onSelectRequest, onBack, onClose }) => {
  return (
    <Panel title="Performance Monitor" onBack={onBack} onClose={onClose}>
      <div>
        {requests.map((request) => (
          <div key={request.id} style={requestsViewStyles.requestItem}>
            <div style={requestsViewStyles.requestHeader}>
              <span style={requestsViewStyles.duration}>{(request.durationTotal / 1000).toFixed(2)} s</span>
              <span style={requestsViewStyles.name}>{request.name}</span>
              <div style={requestsViewStyles.badgeContainer}>
                {request?.bulletWarnings && request?.bulletWarnings.length > 0 && (
                  <span
                    style={requestsViewStyles.bulletWarningBadge}
                    onClick={(e) => {
                      e.stopPropagation();
                      onSelectRequest('bullet', request.id);
                    }}
                  >
                    ⚠ {request.bulletWarnings.length}
                  </span>
                )}
                {request.memoryProfiler && (
                  <span
                    style={requestsViewStyles.memoryBadge}
                    onClick={(e) => {
                      e.stopPropagation();
                      onSelectRequest('memory', request.id);
                    }}
                  >
                    {request.memoryProfiler.total_allocated_memsize_mb.toFixed(1)} MB
                  </span>
                )}

                {request.miniProfiler?.data?.root?.children?.some((child: any) => child.sql_timings?.length > 0) && (
                  <>
                    <span
                      style={requestsViewStyles.sqlBadge}
                      onClick={(e) => {
                        e.stopPropagation();
                        onSelectRequest('sql', request.id);
                      }}
                    >
                      SQL {request.miniProfiler?.data.sql_count || 0}
                    </span>
                    <span style={collapsedViewStyles.timeIndicator}>({(request.durationSql / 1000).toFixed(2)} s)</span>
                  </>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </Panel>
  );
};
